/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipient_StudentInputs */

const en_recipient_student = /** @type {(inputs: Recipient_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`student`)
};

const he_recipient_student = /** @type {(inputs: Recipient_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תלמיד`)
};

/**
* | output |
* | --- |
* | "student" |
*
* @param {Recipient_StudentInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const recipient_student = /** @type {((inputs?: Recipient_StudentInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipient_StudentInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recipient_student(inputs)
	return he_recipient_student(inputs)
});